<template>
    <div>
        <p class='title' style='margin: 20px 0 10px; font-size: 18px; color: #FF6464;'>基本信息</p>
        <div class='info-list'>
            <div class='list-item'>
                <p class='key'>抖音号:</p>
                <p class='value'>{{info.douyin_mark}}</p>
            </div>
            <div class='list-item'>
                <p class='key'>抖音账号称呼:</p>
                <p class='value'>{{info.name}}</p>
            </div>
            <div class='list-item'>
                <p class='key'>抖音账号头像:</p>
                <div class='value'>
                    <img style='width: 50px; height: 50px;' :src='info.avatar' alt='avatar' />
                </div>
            </div>
            <div class='list-item'>
                <p class='key'>注册地区:</p>
                <p class='value'>{{info.country}} - {{info.province}} - {{info.city}}</p>
            </div>
            <div class='list-item'>
                <p class='key'>性别:</p>
                <p class='value'>{{dyCheckInfo.sex[info.sex]}}</p>
            </div>
            <div class='list-item'>
                <p class='key'>账号类型:</p>
                <p class='value'>{{dyCheckInfo.e_account_role[info.e_account_role]}}</p>
            </div>
            <div class='list-item'>
                <p class='key'>手机号:</p>
                <div class='value'>
                    <el-tooltip effect="dark" :content="info.phone" placement="right">
                        <img style='width: 32px; height: 30px;' :src="require('@/index/assets/img/eye.png')" alt='mobile' />
                    </el-tooltip>
                </div>
            </div>
            <div class='list-item'>
                <p class='key'></p>
                <p class='value'></p>
            </div>
            <div class='list-item'>
                <p class='key'>粉丝总数:</p>
                <p class='value'>{{info.count}}</p>
            </div>
            <div class='list-item'>
                <p class='key'>
                    <span>7日新增关注数:</span>
                    <el-tooltip effect="dark" content="该数据需要24小时整理后，才能查看" placement="right">
                        <i class='el-icon-question' style='font-size: 16px; color: #FF6464;'></i>
                    </el-tooltip>
                </p>
                <p class='value'>{{handleTableDataCount('fresh_fans')}}</p>
            </div>
            <div class='list-item'>
                <p class='key'>
                    <span>发布作品数:</span>
                    <el-tooltip effect="dark" content="该数据需要24小时整理后，才能查看" placement="right">
                        <i class='el-icon-question' style='font-size: 16px; color: #FF6464;'></i>
                    </el-tooltip>
                </p>
                <p class='value'>{{handleTableDataCount('new_content')}}</p>
            </div>
            <div class='list-item'>
                <p class='key'></p>
                <p class='value'></p>
            </div>
        </div>
        <div style='padding-top: 20px;'>
            <div class='tag-info'>
                <p style='font-size: 16px; margin-right: 6px;'>官方的标签词：</p>
                <el-tag v-for='item in handleParm(info.antistop)' :key='item' size='mini' style='margin-right: 6px;'>{{item}}</el-tag>
                <span v-show='!handleParm(info.antistop).length'>-</span>
            </div>
            <p style='font-size: 12px; color: #FF6464;'>数字越高说明潜在搜索可能性越高，该数据需要24小时整理后，才能查看</p>
        </div>
        <div style='padding-top: 20px;'>
            <div class='tag-info'>
                <p style='font-size: 16px; margin-right: 6px;'>评价标签：</p>
                <el-tag v-for='item in handleParm(info.fans_antistop)' :key='item' size='mini' style='margin-right: 6px;'>{{item}}</el-tag>
                <span v-show='!handleParm(info.fans_antistop).length'>-</span>
            </div>
            <p style='font-size: 12px; color: #FF6464;'>数字越高说明契合度越高，该数据需要24小时整理后，才能查看</p>
        </div>
        <div style='padding-top: 20px;'>
            <div class='tag-info'>
                <p style='font-size: 16px; margin-right: 6px;'>粉丝年龄分布：</p>
                <el-tag v-for='item in info.fans_age_distributes' :key='item' size='mini' style='margin-right: 6px;'>{{item}}</el-tag>
                <span v-show='!info.fans_age_distributes.length'>-</span>
            </div>
            <p style='font-size: 12px; color: #FF6464;'>数字代表人数，该数据需要24小时整理后，才能查看</p>
        </div>
        <div style='padding-top: 20px;'>
            <div class='tag-info'>
                <p style='font-size: 16px; margin-right: 6px;'>粉丝地区分布：</p>
                <el-tag v-for='item in info.territory_distributes' :key='item' size='mini' style='margin-right: 6px;'>{{item}}</el-tag>
                <span v-show='!info.territory_distributes.length'>-</span>
            </div>
            <p style='font-size: 12px; color: #FF6464;'>数字代表人数，该数据需要24小时整理后，才能查看</p>
        </div>
    </div>
</template>

<script>
import { dyCheckInfo } from '../../../config'

export default {
    props: {
        infoData: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            dyCheckInfo,
        }
    },
    methods: {
        // 传入字符串, 返回英文逗号分隔, 且去除左右空格的字符串数组
        handleParm(str) {
            if (!str) {
                return [];
            }

            return str.split(',').map(item => {
                return item.trim()
            })
        },

        // 传入 key 计算 info.result_list 列表里面 key 的总数
        handleTableDataCount(key) {
            let tableData = this.info.result_list || [];

            tableData = tableData.map(item => {
                return item[key]
            })

            return tableData.reduce((accumulator, currentValue) => {
                return accumulator + currentValue
            }, 0)
        }
    },
    computed: {
        info() {
            return this.infoData
        }
    }
}
</script>

<style lang='scss' scoped>
.info-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .list-item {
        width: 25%;
        margin-bottom: 10px;
        display: flex;
        align-items: center;

        p.key {
            margin-right: 6px;
        }
    }
}
.tag-info {
    display: flex;
    align-items: center;
}

</style>
